import styled from '@emotion/styled';
import { down } from 'styled-breakpoints';

export const ContentContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex: 1;
  min-height: 0; /* Enable flex child shrinking */

  ${down('smallDesktop')} {
    flex-direction: column;
    height: auto;
    min-height: 0;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0; /* Prevent flex item from overflowing */
  display: flex;
  flex-direction: column;
  min-height: 0; /* Enable flex child shrinking */

  ${down('smallDesktop')} {
    height: 400px;
    min-height: 400px;
  }
`;
